import { Link } from "react-router-dom";
import { contact, price } from "../../utils/config";

function PricingTable() {
    return (
        <div className="container">
            <h1>🚀 Launch Your Project Instantly — With Full Deployment & Customization!</h1>

            <p>Get a ready-to-use, professionally built project tailored to your needs. When you buy, you’re not just getting code — you’re getting a complete solution:</p>

            <ul className="list-style-none">
                <li>✅ Full deployment on your server or hosting</li>
                <li>✅ Customization of branding, colors, logo, and settings</li>
                <li>✅ Bug-free, production-ready code</li>
                <li>✅ Support to help you get started</li>
            </ul>

            <p>Perfect for entrepreneurs, startups, or anyone looking to save time and go live fast.</p>

            <p>Buy now and take the first step toward launching your own platform — with zero stress.</p>

            <div id="generic_price_table">   
                <section>
                    <div className="container">
                        <div className="row">
                            <div className="offset-md-2 col-md-4">
                                <div className="generic_content clearfix">
                                    <div className="generic_head_price clearfix">
                                        <div className="generic_head_content clearfix">
                                            <div className="head_bg"></div>
                                            <div className="head">
                                                <span>Free</span>
                                            </div>
                                        </div>

                                        <div className="generic_price_tag clearfix">    
                                            <span className="price">
                                                <span className="sign">$</span>
                                                <span className="currency">0</span>
                                                {/*<span className="cent">.99</span>*/}
                                                {/*<span className="month">/MON</span>*/}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="generic_feature_list">
                                        <ul>
                                            <li><span>Authentication</span></li>
                                            <li><span>Job posting</span></li>
                                            <li><span>CV manager</span></li>
                                            <li><span>Apply on jobs</span></li>
                                            <li><span>View applicant's CVs</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-md-4">
                                <div className="generic_content active clearfix">
                                    <div className="generic_head_price clearfix">
                                        <div className="generic_head_content clearfix">
                                            <div className="head_bg"></div>
                                            <div className="head">
                                                <span>Premium</span>
                                            </div>
                                        </div>

                                        <div className="generic_price_tag clearfix">    
                                            <span className="price">
                                                <span className="sign">$</span>
                                                <span className="currency">{ price }</span>
                                                {/*<span className="cent">.99</span>*/}
                                                {/*<span className="month">/MON</span>*/}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="generic_feature_list">
                                        <ul>
                                            <li>All features of free version +</li>
                                            <li><span>Download multiple CVs at once</span></li>
                                            <li><span>Application status management</span></li>
                                            <li><span>Full candidate profile</span></li>
                                            <li><span>User feed</span></li>
                                            <li><span>Employee management</span></li>
                                            <li><span>Company alerts</span></li>
                                            <li><span>Bookmark job</span></li>
                                            <li><span>Stripe payments</span></li>
                                            <li><span>Chat between recruiter and job seekers</span></li>
                                            <li><span>E-mail campaigns</span></li>
                                            <li><span>Jobs view counter</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </section>
            </div>

            {/*<div className="pricing-table-container">
                <div className="pricing-table">
                  <div className="card">
                    <h2>Free Access</h2>
                    <div className="price">$0 <small>/ forever</small></div>
                    <ul>
                      <li>Use the platform as a user</li>
                      <li>Unlimited usage</li>
                      <li>All core features</li>
                      <li>Regular updates</li>
                      <li>Community Support</li>
                      <li>No access to source code</li>
                    </ul>
                    <Link to="/" className="btn btn-primary">Start Using →</Link>
                  </div>

                  <div className="card">
                    <h2>Source Code</h2>
                    <div className="price">${ price } <small>(one-time)</small></div>
                    <ul>
                      <li>Deploy, modify, and host (we will help you)</li>
                      <li>Full source code access</li>
                      <li>Lifetime access</li>
                      <li>Priority E-mail and WhatsApp support</li>
                      <li>Full customization rights</li>
                      <li>One-time payment, no recurring fees</li>
                    </ul>
                    <a href="#" className="btn btn-secondary no-border" onClick={ function (event) {
                        event.preventDefault();

                        if (typeof window.tidioChatApi !== "undefined") {
                            window.tidioChatApi.open();
                        } else {
                            window.location.href = "mailto:" + contact.email;
                        }
                    } }>Buy Source Code →</a>
                  </div>
                </div>
              </div>*/}
        </div>
    );
}

export default PricingTable;